export const professionCategories = [
  {
    id: 'tech',
    name: 'Technologie & Informatique',
    icon: 'ri-code-s-slash-line',
    professions: [
      'Développeur',
      'Ingénieur logiciel',
      'Ingénieur IA',
      'Data Analyst',
      'Data Scientist',
      'Expert cybersécurité',
      'Administrateur systèmes & réseaux',
      'Expert Cloud',
      'UX/UI Designer',
      'Technicien informatique',
    ],
  },
  {
    id: 'business',
    name: 'Business & Management',
    icon: 'ri-briefcase-line',
    professions: [
      'Entrepreneur',
      'Consultant',
      'Business Developer',
      'Manager',
      'Chef de projet',
      'Directeur',
      'Responsable commercial',
      'Responsable des opérations',
      'Analyste business',
      'Assistant de direction',
    ],
  },
  {
    id: 'finance',
    name: 'Finance, Banque & Comptabilité',
    icon: 'ri-bank-line',
    professions: [
      'Comptable',
      'Expert-comptable',
      'Auditeur',
      'Analyste financier',
      'Conseiller financier',
      'Gestionnaire de patrimoine',
      'Contrôleur de gestion',
      'Banquier',
      'Fiscaliste',
      'Économiste',
    ],
  },
  {
    id: 'droit',
    name: 'Droit & Juridique',
    icon: 'ri-scales-3-line',
    professions: [
      'Avocat',
      'Juriste',
      'Notaire',
      'Magistrat',
      'Conseiller juridique',
      'Médiateur',
      'Assistant juridique',
    ],
  },
  {
    id: 'sante',
    name: 'Santé & Médecine',
    icon: 'ri-heart-pulse-line',
    professions: [
      'Médecin',
      'Infirmier',
      'Pharmacien',
      'Dentiste',
      'Sage-femme',
      'Kinésithérapeute',
      'Psychologue',
      'Nutritionniste',
      'Technicien médical',
      'Vétérinaire',
    ],
  },
  {
    id: 'education',
    name: 'Éducation & Formation',
    icon: 'ri-graduation-cap-line',
    professions: [
      'Enseignant',
      'Professeur',
      'Formateur',
      'Éducateur',
      'Tuteur',
      'Coach',
      'Consultant pédagogique',
      'Créateur de cours',
    ],
  },
  {
    id: 'construction',
    name: 'Construction & Ingénierie',
    icon: 'ri-building-2-line',
    professions: [
      'Architecte',
      'Ingénieur civil',
      'Ingénieur mécanique',
      'Ingénieur électrique',
      'Maçon',
      'Électricien',
      'Plombier',
      'Soudeur',
      'Menuisier',
      'Conducteur de travaux',
    ],
  },
  {
    id: 'design',
    name: 'Design, Art & Création',
    icon: 'ri-palette-line',
    professions: [
      'Graphiste',
      'Designer',
      'Photographe',
      'Vidéaste',
      'Monteur vidéo',
      'Illustrateur',
      'Artiste',
      'Animateur 2D/3D',
      'Directeur artistique',
      'Designer de mode',
    ],
  },
  {
    id: 'marketing',
    name: 'Marketing, Communication & Médias',
    icon: 'ri-megaphone-line',
    professions: [
      'Responsable marketing',
      'Expert SEO',
      'Community Manager',
      'Social Media Manager',
      'Copywriter',
      'Rédacteur',
      'Journaliste',
      'Créateur de contenu',
      'Relations publiques',
      'Media Buyer',
    ],
  },
  {
    id: 'commerce',
    name: 'Commerce & E-commerce',
    icon: 'ri-shopping-bag-line',
    professions: [
      'Commercial',
      'Vendeur',
      'Acheteur',
      'Responsable boutique',
      'E-commerçant',
      'Importateur',
      'Exportateur',
      'Grossiste',
      'Détaillant',
      'Responsable des ventes',
    ],
  },
  {
    id: 'transport',
    name: 'Transport & Logistique',
    icon: 'ri-truck-line',
    professions: [
      'Chauffeur',
      'Chauffeur-livreur',
      'Conducteur poids lourd',
      'Logisticien',
      'Gestionnaire de stock',
      'Magasinier',
      'Transitaire',
      'Responsable logistique',
      'Agent de transport',
    ],
  },
  {
    id: 'hotellerie',
    name: 'Hôtellerie, Restauration & Tourisme',
    icon: 'ri-restaurant-line',
    professions: [
      'Hôtelier',
      'Réceptionniste',
      'Chef cuisinier',
      'Cuisinier',
      'Pâtissier',
      'Serveur',
      'Traiteur',
      'Guide touristique',
      'Agent de voyage',
      "Organisateur d'événements",
    ],
  },
  {
    id: 'agriculture',
    name: 'Agriculture, Élevage & Pêche',
    icon: 'ri-plant-line',
    professions: [
      'Agriculteur',
      'Agronome',
      'Éleveur',
      'Pêcheur',
      'Technicien agricole',
      'Horticulteur',
      'Apiculteur',
      'Paysagiste',
      'Aquaculteur',
    ],
  },
  {
    id: 'industrie',
    name: 'Industrie & Métiers techniques',
    icon: 'ri-settings-3-line',
    professions: [
      'Mécanicien',
      'Électrotechnicien',
      'Électronicien',
      'Technicien industriel',
      'Opérateur industriel',
      'Technicien de maintenance',
      'Contrôleur qualité',
      'Ingénieur industriel',
    ],
  },
  {
    id: 'mode',
    name: 'Mode, Beauté & Artisanat',
    icon: 'ri-scissors-cut-line',
    professions: [
      'Styliste',
      'Couturier',
      'Tailleur',
      'Modéliste',
      'Coiffeur',
      'Barbier',
      'Maquilleur',
      'Esthéticien',
      'Bijoutier',
      'Artisan',
    ],
  },
  {
    id: 'immobilier',
    name: 'Immobilier & Habitat',
    icon: 'ri-home-4-line',
    professions: [
      'Agent immobilier',
      'Promoteur immobilier',
      'Gestionnaire immobilier',
      'Décorateur',
      "Designer d'intérieur",
      'Gestionnaire de propriété',
      'Expert immobilier',
    ],
  },
  {
    id: 'sciences',
    name: 'Sciences & Recherche',
    icon: 'ri-microscope-line',
    professions: [
      'Chercheur',
      'Scientifique',
      'Biologiste',
      'Chimiste',
      'Physicien',
      'Mathématicien',
      'Géologue',
      'Statisticien',
      'Laborantin',
    ],
  },
  {
    id: 'energie',
    name: 'Énergie & Environnement',
    icon: 'ri-leaf-line',
    professions: [
      'Ingénieur énergie',
      'Technicien solaire',
      'Installateur photovoltaïque',
      'Expert environnement',
      'Ingénieur environnement',
      'Gestionnaire des déchets',
      'Technicien énergie',
    ],
  },
  {
    id: 'securite',
    name: 'Sécurité & Protection',
    icon: 'ri-shield-check-line',
    professions: [
      'Agent de sécurité',
      'Responsable sécurité',
      'Pompier',
      'Agent de prévention',
      'Garde',
      'Consultant sécurité',
    ],
  },
  {
    id: 'international',
    name: 'International, ONG & Développement',
    icon: 'ri-global-line',
    professions: [
      'Chargé de projet',
      'Coordinateur de projet',
      'Humanitaire',
      'Consultant international',
      'Diplomate',
      'Traducteur',
      'Interprète',
      'Responsable ONG',
    ],
  },
  {
    id: 'digital',
    name: 'Nouveaux métiers & Digital',
    icon: 'ri-rocket-line',
    professions: [
      'Consultant IA',
      'Prompt Engineer',
      'Spécialiste automatisation',
      'Expert No-Code',
      'Expert Blockchain',
      'Développeur Web3',
      'Consultant transformation digitale',
      'Spécialiste e-commerce',
    ],
  },
  {
    id: 'administration',
    name: 'Administration & Services',
    icon: 'ri-clipboard-line',
    professions: [
      'Assistant administratif',
      'Secrétaire',
      'Gestionnaire administratif',
      "Agent d'accueil",
      'Ressources humaines',
      'Recruteur',
      'Responsable RH',
      'Gestionnaire de paie',
    ],
  },
  {
    id: 'gouvernement',
    name: 'Gouvernement & Secteur public',
    icon: 'ri-government-line',
    professions: [
      'Fonctionnaire',
      'Administrateur public',
      'Agent territorial',
      'Inspecteur',
      'Conseiller politique',
      'Responsable administratif',
    ],
  },
  {
    id: 'sport',
    name: 'Sport & Fitness',
    icon: 'ri-run-line',
    professions: [
      'Athlète',
      'Entraîneur',
      'Coach sportif',
      'Préparateur physique',
      'Arbitre',
      'Professeur de sport',
      'Nutritionniste sportif',
      'Manager sportif',
    ],
  },
  {
    id: 'divertissement',
    name: 'Divertissement & Culture',
    icon: 'ri-movie-line',
    professions: [
      'Acteur',
      'Musicien',
      'Chanteur',
      'Producteur',
      'Réalisateur',
      'Danseur',
      'Animateur',
      'DJ',
      'Écrivain',
      'Producteur audiovisuel',
    ],
  },
];